import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <div className="mb-4 flex items-center">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-gray-900">Something went wrong</h3>
          </div>
        </div>
        <div className="mt-2 text-sm text-gray-500">
          <p>
            We're sorry, but something unexpected happened. Our team has been notified. Please try refreshing
            the page.
          </p>
        </div>
        <div className="mt-6">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:outline-none sm:text-sm">
            Refresh Page
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
